import { Base } from '@studiometa/js-toolkit';
import MenuItem from './MenuItem.js';
import CanvasBubbles from '../CanvasBubbles.js';
import Collapse from '../../molecules/Collapse/index.js';

/**
 * @typedef {object} MenuRefs
 * @property {HTMLButtonElement} openMenu
 * @property {HTMLElement} media
 * @property {HTMLElement} menu
 */
/**
 * @typedef {object} MenuInterface
 * @property {MenuRefs} $refs
 */

/**
 * Menu
 */
export default class Menu extends Base {
  /**
   * Configuration
   */
  static config = {
    name: 'Menu',
    components: {
      MenuItem,
      CanvasBubbles,
      Collapse,
    },
    refs: ['openMenu', 'menu', 'menuList'],
  };

  /**
   * mounted hook
   */
  mounted() {
    this.$children.CanvasBubbles[0].$destroy();
  }

  /**
   * @member {boolean} isOpen
   */
  isOpen = false;

  /**
   * Burger menu
   * @returns {Function}
   */
  onOpenMenuClick() {
    if (this.isOpen) {
      return this.close();
    }

    return this.open();
  }

  /**
   * open
   */
  open() {
    this.isOpen = true;
    document.body.classList.add('is-menu-open');
    document.body.classList.remove('has-black-text');
    document.body.classList.add('overflow-hidden');
    this.$children.CanvasBubbles[0].$mount();
  }

  /**
   * close
   */
  close() {
    this.isOpen = false;
    document.body.classList.remove('is-menu-open');
    document.body.classList.add('has-black-text');
    document.body.classList.remove('overflow-hidden');
    this.$children.CanvasBubbles[0].$destroy();
  }

  /**
   * Keyed service hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#keyed
   * @param {object} props The keyed serivce props.
   * @param {boolean} props.ESC Will be true if the key initiating the event is the esc key.
   */
  keyed({ ESC }) {
    if (ESC) {
      this.close();
    }
  }
}
